import React from "react";
import { TypeAnimation } from 'react-type-animation';

export default function Banner() {
    return (
        <div id="home" className="section container mx-auto mx-w-[200px] px-3 items-center">
            <div className="w-full ">
                
                <div className="block text-center font-secondary font-black text-[20px] ">

               <div>Hallo Semua 🙏🙏🙏</div>
            <TypeAnimation
                sequence={[
                    'Saya Darius Amenda',
                    3000, // wait 1s before replacing "Mice" with "Hamsters"
                    'Fronted Developer ',
                    3000,
                    'Backend Developer ',
                    3000,
                    'Jangan Lupa Follow',
                    3000
                ]}
                wrapper="span"
               cursor={true}
                repeat={Infinity}
                className="mx-3 text-gradient"
            />
             </div>
             <p className="text-justify font-times" data-aos="fade-right"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">"Setiap baris kode adalah langkah kecil menuju impian besar. Jangan takut untuk mencoba, salah, dan belajar. Pemrograman adalah seni untuk memecahkan masalah, dan kamu adalah senimannya. Teruslah menulis, teruslah mencari tahu, dan ingat bahwa setiap error adalah tanda bahwa kamu sedang bertumbuh. Jadikan setiap tantangan sebagai batu loncatan menuju kesuksesan. Dengan ketekunan dan rasa ingin tahu, dunia pemrograman akan terbuka lebar untukmu. Semangat, pemrogram masa depan!"

</p>
             </div>
           
        </div>
    );
}
